export const isConsoleUrl = (url: string) =>
  url.includes('console.hasura.io') || url.includes('console.arusah.com');

export const getConsolePlatformType = (url: string) =>
  url.includes('promptql') ? 'promptql_v3_console' : 'hasura_v3_console';
